export default () => ({
  papers: [],
})
